<template>
  <section class="store-section-card"><slot /></section>
</template>

<style scoped>
.store-section-card {
  display: flex;
  min-width: 0;
  flex-direction: column;
  border: 1px solid #e4e7eb;
  border-radius: 12px;
  background: #fff;
  box-shadow:
    0 1px 2px rgba(20, 24, 31, 0.04),
    0 1px 1px rgba(20, 24, 31, 0.03);
  padding: 18px 20px;
}

/* The sections were written to stand apart on a plain page, so each carries its own
   bottom margin and a rule under its heading. The card gives them both. */
.store-section-card :deep(form) {
  margin-bottom: 0;
}
.store-section-card :deep(.space-y-2 > hr) {
  display: none;
}
.store-section-card :deep(h2) {
  font-size: 15px;
  font-weight: 650;
  letter-spacing: -0.005em;
  color: #15181d;
}

@media (max-width: 820px) {
  .store-section-card {
    padding: 16px;
  }
}
</style>
